module.exports = __webpack_public_path__ + "img/mobile_t22.5b63c0a4.png";